const captionText = 'Drag and drop the charms to customize their position';

/**
 * Adds the instructional caption to the app-owned reference card without
 * changing the Charm Bar markup or its drag-and-drop targets.
 */
function addPreviewCaptions() {
  for (const preview of document.querySelectorAll('.charm_bar__preview')) {
    const reference = preview.querySelector('.charm_bar__reference');
    if (!reference) continue;

    const legacyCaption = preview.querySelector(
      ':scope > [data-charm-bar-preview-caption]'
    );
    legacyCaption?.remove();

    if (!reference.querySelector('[data-charm-bar-preview-caption]')) {
      const caption = document.createElement('p');
      caption.className = 'charm_bar__preview-caption';
      caption.dataset.charmBarPreviewCaption = '';
      caption.textContent = captionText;
      reference.append(caption);
    }
  }
}

addPreviewCaptions();

const observer = new MutationObserver(addPreviewCaptions);
observer.observe(document.body, { childList: true, subtree: true });

const mobilePreviewMedia = window.matchMedia('(max-width: 749px)');
const hiddenPreviewClass = 'charm_bar__preview--scroll-hidden';
const initialHiddenPreviewClass =
  'charm_bar__preview--scroll-initial-hidden';
const scrollRevealPreviewClass = 'charm_bar__preview--scroll-reveal';
const stickyOffset = 60;
const previewHideDelay = 180;
const previewScrollThresholds = new WeakMap();
const controller = new AbortController();
let previousScrollY = Math.max(window.scrollY, 0);
let scrollFrame;
let previewHideTimer;
let pendingPreviewHide;

function cancelPreviewHide(preview) {
  if (pendingPreviewHide !== preview) return;

  window.clearTimeout(previewHideTimer);
  previewHideTimer = undefined;
  pendingPreviewHide = undefined;
}

function schedulePreviewHide(preview) {
  if (
    preview.classList.contains(hiddenPreviewClass) ||
    pendingPreviewHide === preview
  ) {
    return;
  }

  if (pendingPreviewHide) cancelPreviewHide(pendingPreviewHide);

  pendingPreviewHide = preview;
  previewHideTimer = window.setTimeout(() => {
    preview.classList.add(hiddenPreviewClass);
    previewHideTimer = undefined;
    pendingPreviewHide = undefined;
  }, previewHideDelay);
}

function updateMobilePreviewVisibility() {
  scrollFrame = undefined;

  const currentScrollY = Math.max(window.scrollY, 0);
  const isScrollingUp = currentScrollY < previousScrollY;
  const isScrollingDown = currentScrollY > previousScrollY;

  for (const preview of document.querySelectorAll('.charm_bar__preview')) {
    if (
      mobilePreviewMedia.matches &&
      !preview.classList.contains(scrollRevealPreviewClass)
    ) {
      const previewBounds = preview.getBoundingClientRect();
      const previewTop = currentScrollY + previewBounds.top;
      const previewBottom = currentScrollY + previewBounds.bottom;

      previewScrollThresholds.set(preview, {
        handoff: previewTop - stickyOffset,
        reveal: previewBottom - stickyOffset,
      });
    }

    const thresholds = previewScrollThresholds.get(preview);
    const hasScrolledPastPreview =
      thresholds != null && currentScrollY >= thresholds.reveal;
    const hasReachedPreviewHandoff =
      thresholds != null && currentScrollY <= thresholds.handoff;
    const isScrollRevealActive = preview.classList.contains(
      scrollRevealPreviewClass
    );

    if (
      !mobilePreviewMedia.matches ||
      (isScrollRevealActive && hasReachedPreviewHandoff) ||
      (!isScrollRevealActive && !hasScrolledPastPreview)
    ) {
      cancelPreviewHide(preview);
      preview.classList.remove(scrollRevealPreviewClass);
      preview.classList.remove(hiddenPreviewClass);
      preview.classList.remove(initialHiddenPreviewClass);
    } else if (isScrollingUp || currentScrollY === 0) {
      cancelPreviewHide(preview);
      preview.classList.add(scrollRevealPreviewClass);
      preview.classList.remove(hiddenPreviewClass);
      preview.classList.remove(initialHiddenPreviewClass);
    } else if (isScrollingDown) {
      const wasScrollRevealActive = preview.classList.contains(
        scrollRevealPreviewClass
      );
      const isScrollRevealVisible =
        wasScrollRevealActive && !preview.classList.contains(hiddenPreviewClass);

      preview.classList.add(scrollRevealPreviewClass);

      if (isScrollRevealVisible) {
        schedulePreviewHide(preview);
      } else {
        preview.classList.add(hiddenPreviewClass);

        if (!wasScrollRevealActive) {
          preview.classList.add(initialHiddenPreviewClass);
        }
      }
    }
  }

  previousScrollY = currentScrollY;
}

function scheduleMobilePreviewUpdate() {
  if (scrollFrame) return;

  scrollFrame = window.requestAnimationFrame(updateMobilePreviewVisibility);
}

window.addEventListener('scroll', scheduleMobilePreviewUpdate, {
  passive: true,
  signal: controller.signal,
});
mobilePreviewMedia.addEventListener('change', scheduleMobilePreviewUpdate, {
  signal: controller.signal,
});

window.addEventListener(
  'pagehide',
  () => {
    observer.disconnect();
    controller.abort();

    if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
    if (previewHideTimer) window.clearTimeout(previewHideTimer);
  },
  { once: true }
);
